import React from 'react';
import { motion } from 'framer-motion';
import { Search, Bell, Home, MapPin, Heart, User, Star, Clock, Flame } from 'lucide-react';
import { DineoraMark } from './Logo';

const RESTAURANTS = [
  { name: "Nonna's Kitchen", meta: 'Italian · 0.8 km', rating: '4.9', tone: 'from-[#f15a24] to-[#d94a1a]' },
  { name: 'Maple & Smoke', meta: 'BBQ · 1.2 km', rating: '4.8', tone: 'from-[#3d2b1f] to-[#1f1712]' },
  { name: 'Umi Counter', meta: 'Sushi · 2.1 km', rating: '4.7', tone: 'from-[#e8b884] to-[#c98d4e]' },
];

const PhoneMockup = () => (
  <motion.div
    initial={{ opacity: 0, y: 60, rotate: 4 }}
    animate={{ opacity: 1, y: 0, rotate: 2 }}
    transition={{ duration: 1.1, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ rotate: 0, scale: 1.02 }}
    className="relative [perspective:1200px]"
    data-testid="hero-phone-mockup"
  >
    <motion.div
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
      className="w-[280px] sm:w-[300px] rounded-[44px] bg-[#111110] p-2.5 shadow-[0_40px_90px_-20px_rgba(17,16,16,0.45)]"
    >
      <div className="rounded-[34px] bg-[#faf9f6] overflow-hidden flex flex-col h-[560px] sm:h-[590px]">
        <div className="flex items-center justify-between px-6 pt-4 pb-1">
          <span className="text-[10px] font-semibold text-[#171512]">9:41</span>
          <span className="w-20 h-5 bg-[#111110] rounded-full" aria-hidden="true" />
          <span className="flex gap-1 items-center" aria-hidden="true">
            <span className="w-3.5 h-2 rounded-[2px] bg-[#171512]" />
          </span>
        </div>

        <div className="flex items-center justify-between px-5 pt-3">
          <img src="/logo-dineora.png" alt="DineOra" className="h-3.5 w-auto" />
          <span className="w-8 h-8 rounded-full bg-white border border-black/10 flex items-center justify-center">
            <Bell size={13} className="text-[#171512]" aria-hidden="true" />
          </span>
        </div>

        <div className="mx-5 mt-3 flex items-center gap-2 bg-white border border-black/10 rounded-full px-4 py-2.5">
          <Search size={13} className="text-[#97917f]" aria-hidden="true" />
          <span className="text-[11px] text-[#97917f]">Search independents near you</span>
        </div>

        <div className="flex gap-2 px-5 mt-3">
          {['Pizza', 'Sushi', 'Brunch', 'Thai'].map((c, i) => (
            <span
              key={c}
              className={`text-[10px] font-semibold rounded-full px-3 py-1.5 ${
                i === 0 ? 'bg-[#111110] text-white' : 'bg-white border border-black/10 text-[#6e6a63]'
              }`}
            >
              {c}
            </span>
          ))}
        </div>

        <div className="px-5 mt-4 space-y-3 flex-1">
          {RESTAURANTS.map((r) => (
            <div key={r.name} className="bg-white border border-black/10 rounded-2xl overflow-hidden">
              <div className={`h-16 bg-gradient-to-br ${r.tone} flex items-center justify-center`}>
                <Flame size={18} className="text-white/80" aria-hidden="true" />
              </div>
              <div className="p-3">
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-bold text-[#171512]">{r.name}</p>
                  <span className="flex items-center gap-1 text-[10px] font-semibold text-[#171512]">
                    <Star size={10} className="text-[#f15a24] fill-[#f15a24]" aria-hidden="true" /> {r.rating}
                  </span>
                </div>
                <p className="text-[10px] text-[#97917f] mt-0.5 flex items-center gap-1">
                  <Clock size={9} aria-hidden="true" /> {r.meta} · Direct
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-around border-t border-black/10 bg-white px-6 py-3.5">
          <Home size={17} className="text-[#f15a24]" aria-hidden="true" />
          <MapPin size={17} className="text-[#b7b1a6]" aria-hidden="true" />
          <Heart size={17} className="text-[#b7b1a6]" aria-hidden="true" />
          <User size={17} className="text-[#b7b1a6]" aria-hidden="true" />
        </div>
      </div>
    </motion.div>
  </motion.div>
);

export default PhoneMockup;
